export default function ProductsDirective() {
  return {
    template: require('./products.html'),
    scope: {
      vendor: '=',
      products: '=',
      filters: '=',
    },
    controller: 'ProductsController',
    controllerAs: 'productsVM',
    bindToController: true,
    replace: true,
  };
}
